import { cn } from '@nesso/ui/lib/utils';

type Props = {
    className?: string;
};

// bg-secondary-text, not bg-secondary: only the -text token is Figma's base/secondary (#8f3da7) in
// both themes. --secondary is a lighter purple in light mode, which is the clinician default.
export function DictateRecapBeacon({ className }: Props) {
    return (
        <span
            aria-hidden="true"
            className={cn(
                'pointer-events-none absolute -top-[5px] right-0 inline-flex items-center justify-center',
                className,
            )}
        >
            <span className="absolute size-5 rounded-full bg-secondary-text/30 animate-ping [animation-duration:1.5s] motion-reduce:animate-none" />
            <span className="inline-block size-4 rounded-full bg-secondary-text" />
        </span>
    );
}
